<template>
    <div class="knowledge-asset-content text-center">
        <p
            v-if="hasTitleAbove"
            class="asset-title mb-0"
        >
            {{ asset.title }}
        </p>

        <component
                :is="componentType"
                :asset="asset"
                :content-over-image="articleContentOverImage"
                :display-title="! hasTitleAbove"
                :event="event"
                :has-event="hasEvent"
        />
    </div>
</template>

<script>
    import './KnowledgeAssetContent.scss';
    import KnowledgeAssetAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/KnowledgeAssetAppResource";
    import Article from "./Article/Article";
    import Video from "./Video/Video";
    import LandingPageEventAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageEventAppResource";

    export default {
        name: "KnowledgeAssetContent",
        components: {
            Video,
            Article
        },
        props: {
            asset: {
                type: Object,
                required: true,
            },
            articleContentOverImage: {
                type: Boolean,
                default: false
            },
            hasTitleAbove: {
                type: Boolean,
                default: false,
            },
            event: {
                type: LandingPageEventAppResource,
                default: () => new LandingPageEventAppResource({}),
            },
            hasEvent: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {};
        },
        computed: {
            componentType() {
                let type = Article;
                if (this.asset instanceof KnowledgeAssetAppResource) {
                    switch (this.asset.type) {
                        case 'knowledge-asset-article':
                            type = Article;
                            break;
                        case 'knowledge-asset-video':
                            type = Video;
                            break;
                    }
                }
                return type;
            },
        }
    };
</script>
